<template>
  <div>
    <a-skeleton v-if="leading" :active="true" avatar :paragraph="{ rows: 4 }" />
    <div v-else>
      <div class="card card-body" v-if="status != 'active'">
        <div class="row justify-content-xl-center">
          <div class="col-xl-12 col-lg-12">
            <a-page-header
              :title="info.firstName + (info.middleName ? ' ' + info.middleName : '') + ' ' + info.lastName"
              :sub-title="info.classRoom ? info.classRoom.name : 'NON INSCRIT'"
              @back="() => $router.go(-1)"
            >
              <template slot="tags">
                <a-tag color="green">
                  {{ calculateAge(info.BirthDate) }} ANS</a-tag
                >
              </template>
              <div class="row">
                <div class="col-md-1" v-if="info.photo">
                  <div class="kit__utils__avatar kit__utils__avatar--size64">
                    <img
                      :src="
                        settings.resourcesUrl.replace('FILE_PATH', info.photo)
                      "
                      :alt="info.firstName + (info.middleName ? ' ' + info.middleName : '') + ' ' + info.lastName"
                    />
                  </div>
                </div>
                <a-descriptions size="small" :column="2" class="col">
                  <a-descriptions-item :label="$t('sms.pere')">
                    <i :class="['fa', 'fa-male']"></i>
                    {{ info.parent.father.firstName }}
                    {{ info.parent.father.lastName }}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('sms.telephone')">
                    <a-icon type="phone" /> {{ info.parent.father.phone }}
                  </a-descriptions-item>
                  <a-descriptions-item :label="$t('sms.mere')">
                    <i :class="['fa', 'fa-female']"></i>
                    {{ info.parent.mother.firstName }}
                    {{ info.parent.mother.lastName }}
                  </a-descriptions-item>

                  <a-descriptions-item :label="$t('sms.telephone')">
                    <a-icon type="phone" /> {{ info.parent.mother.phone }}
                  </a-descriptions-item>
                  <a-descriptions-item
                    v-if="info.parent && countryIsKE"
                    :label="$t('profil.photoMediaConsentCard')"
                  >
                    <a-tag
                      v-if="info.parent.photoMediaPromotionalConsent === true"
                      color="green"
                      >{{ $t("liste.photoMediaConsentAccepted") }}</a-tag
                    >
                    <a-tag
                      v-else-if="
                        info.parent.photoMediaPromotionalConsent === false
                      "
                      color="red"
                      >{{ $t("liste.photoMediaConsentRefused") }}</a-tag
                    >
                    <a-tag v-else color="orange">{{
                      $t("liste.photoMediaConsentPending")
                    }}</a-tag>
                  </a-descriptions-item>
                </a-descriptions>
              </div>
            </a-page-header>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row justify-content-xl-center" v-if="status == 'active'">
          <div class="col-xl-3 col-lg-12">
            <div class="card">
              <div class="card-body">
                <profile-card
                  :id="info._id"
                  :fullName="info.firstName + (info.middleName ? ' ' + info.middleName : '') + ' ' + info.lastName"
                  :classRoom="info.classRoom ? info.classRoom.name : ''"
                  :classRoomId="info.classRoom ? info.classRoom._id : ''"
                  :profileImage="info.photo"
                  :birthDay="info.BirthDate"
                />

                <!-- <MultiPaymentValidater
                  class="mt-2"
                  :idParent="info.parent._id"
                  :student="info"
                  @reload="reload"
                  :classroomName="info.classRoom ? info.classRoom.name : ''"
                />-->
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-12">
            <div class="card">
              <div class="card-body">
                <a-divider class="text-uppercase font-size-13"
                  ><i :class="['fa', 'fa-male']"></i>
                  {{ info.parent.father.firstName }}
                  {{ info.parent.father.lastName }}</a-divider
                >

                <div class="alert alert-light font-size-11 p-2">
                  <a-icon type="phone" /> {{ info.parent.father.phone }}
                </div>
                <a-divider class="text-uppercase font-size-13"
                  ><i :class="['fa', 'fa-female']"></i>
                  {{ info.parent.mother.firstName }}
                  {{ info.parent.mother.lastName }}</a-divider
                >
                <div class="alert alert-light font-size-11 p-2">
                  <a-icon type="phone" /> {{ info.parent.mother.phone }}
                </div>

                <template v-if="info.parent && countryIsKE">
                  <div class="parent-photo-consent-wrap">
                    <div class="parent-photo-consent-title">
                      {{ $t("profil.photoMediaConsentCard") }}
                    </div>
                    <div class="text-center mb-1">
                      <a-tag
                        v-if="info.parent.photoMediaPromotionalConsent === true"
                        color="green"
                        >{{ $t("liste.photoMediaConsentAccepted") }}</a-tag
                      >
                      <a-tag
                        v-else-if="
                          info.parent.photoMediaPromotionalConsent === false
                        "
                        color="red"
                        >{{ $t("liste.photoMediaConsentRefused") }}</a-tag
                      >
                      <a-tag v-else color="orange">{{
                        $t("liste.photoMediaConsentPending")
                      }}</a-tag>
                    </div>
                    <div
                      class="parent-photo-consent-hint text-muted text-center mb-2"
                    >
                      {{ $t("profil.photoMediaConsentHint") }}
                    </div>
                  </div>
                </template>

                <div class="text-center">
                  <a-button-group class="d-flex justify-content-center">
                    <PaymentStatus
                      :currentParent="info.parent._id"
                      :selectedStudent="studentId"
                      :profile="true"
                      :class="{
                        disabledPack:
                          !btnAccessGetter.includes('paymentStatus'),
                      }"
                    />
                  </a-button-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-12">
            <control-parentale
              :idParent="info.parent._id"
              :info="info.parent"
              :loginHashes="loginHashes"
              @parentUpdated="parentalControlUpdated"
              @requestLoginHash="requestLoginHash"
            />
          </div>
          <div class="col-xl-3 col-lg-12">
            <student-credentials
              :idStudent="info._id"
              :userName="info.userName"
              :phone="info.phone"
              :status="info.status || 'active'"
              :loginHash="currentStudentHash"
            />
          </div>
        </div>
        <div class="row" v-if="verifyTabsAccess()">
          <div class="card col-xl-12 col-lg-12">
            <div class="card-header card-header-flex flex-column">
              <a-tabs
                class="kit-tabs kit-tabs-bold overflow-hidden"
                :default-active-key="activeKey"
                pagination="bottom"
                @change="callback"
              >
                <a-tab-pane
                  v-if="verifyRoleAccess(['all', 'profil_information'])"
                  :tab="$t('profil.informations')"
                  key="1"
                />
                <a-tab-pane
                  v-if="
                    verifyRoleAccess([
                      'all',
                      'paiement_scolarite',
                      'paiement_activite',
                    ])
                  "
                  :tab="$t('paiement.reductionBase')"
                  key="9"
                />
                <a-tab-pane
                  v-if="verifyRoleAccess(['all', 'paiement_scolarite'])"
                  :tab="$t('profil.paiementScol')"
                  key="2"
                />
                <a-tab-pane
                  v-if="verifyRoleAccess(['all', 'paiement_activite'])"
                  :tab="$t('profil.paiementAct')"
                  key="3"
                />
                <a-tab-pane
                  v-if="
                    verifyRoleAccess([
                      'all',
                      'paiement_scolarite',
                      'paiement_activite',
                    ])
                  "
                  key="10"
                >
                  <span slot="tab">
                    <a-icon type="credit-card" />
                    {{ $t("finance.invoiceBuilder") }}
                  </span>
                </a-tab-pane>
                <a-tab-pane
                  v-if="verifyRoleAccess(['all', 'liste_reglement'])"
                  :tab="$t('profil.listeReglements')"
                  key="4"
                />
                <a-tab-pane
                  v-if="
                    verifyRoleAccess(['all', 'qr_code']) && status == 'active'
                  "
                  key="6"
                  tab="Qr code"
                >
                  <div>
                    <vue-qr
                      :text="qrData"
                      :logoSrc="getBuilding.logo"
                      :callback="getQrImage"
                      qid="student"
                    ></vue-qr>
                    <a-button
                      type="button"
                      class="btn btn-primary"
                      @click="generatePdf"
                      :loading="loadingBadge"
                      :disabled="loadingBadge"
                      style="position: relative; z-index: 99"
                      :class="{
                        disabledPack: !btnAccessGetter.includes(
                          'prBadge'
                        ),
                      }"
                      ><i
                        class="fa fa-address-card-o mr-2"
                        aria-hidden="true"
                      />

                      {{ $t("action.simpleBadge") }}
                    </a-button>
                    <a-button
                      type="button"
                      class="btn btn-primary ml-2"
                      @click="generateNewBadge"
                      :loading="loadingBadge"
                      :disabled="loadingBadge"
                      style="position: relative; z-index: 99"
                      :class="{
                        disabledPack:
                          !btnAccessGetter.includes('prBadgePhoto'),
                      }"
                      ><i
                        class="fa fa-address-card-o mr-2"
                        aria-hidden="true"
                      />

                      {{ $t("action.badgeAvecPhoto") }}
                    </a-button>
                  </div>
                </a-tab-pane>
                <a-tab-pane
                  v-if="verifyRoleAccess(['all', 'bulletin'])"
                  :tab="$t('bulletin.notes')"
                  key="7"
                />
                <a-tab-pane
                  v-if="verifyRoleAccess(['all', 'assiduite'])"
                  :tab="$t('assiduite.assiduite')"
                  key="8"
                />
              </a-tabs>
            </div>
            <div class="card-body px-2">
              <!--Informations tab 1-->
              <a-collapse
                v-model="activeCollapseKey"
                expand-icon-position="right"
                v-if="activeKey == '1'"
              >
                <a-collapse-panel key="1" :header="$t('profil.historique')">
                  <a-icon slot="extra" type="hourglass" />
                  <div class="row">
                    <div class="col-lg-6 d-inline-block">
                      <label>{{ $t("profil.ajouteLe") }} : </label>
                      <span class="text-muted">
                        {{ moment(info.createdAt).format(" DD/MM/YYYY hh:mm") }}
                      </span>
                    </div>
                    <div class="col-lg-6">
                      <label>{{ $t("profil.lastModifi") }} : </label>
                      <span class="text-muted">{{
                        moment(info.updatedAt).format(" DD/MM/YYYY hh:mm")
                      }}</span>
                    </div>
                  </div>
                  <a-divider></a-divider>
                  <div class="row">
                    <div class="col-lg-6">
                      <p class="mt-2 mb-3">{{ $t("profil.historique") }} :</p>
                      <div class="card" style="height: auto; min-height: 145px">
                        <div class="card-body">
                          <div
                            v-for="year in schoolHistory"
                            :key="year._id"
                            class="mt-1"
                          >
                            {{ year.year }} :
                            <a-tag color="blue"
                              >{{ year.classroomName }}
                            </a-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" v-if="status != 'active'">
                      <a-alert
                        :message="`${$t('liste.reasonArchive')} :  ${
                          info.reasonArchive || '--'
                        }`"
                        type="warning"
                      />
                    </div>
                  </div>
                </a-collapse-panel>
                <a-collapse-panel key="2" :header="$t('liste.parents')">
                  <a-icon slot="extra" type="team" />
                  <parent-expand
                    :parentID="info.parent._id"
                    @parentUpdated="parentUpdated"
                  />
                </a-collapse-panel>
                <a-collapse-panel key="3" :header="$t('menu.generale')">
                  <a-icon slot="extra" type="setting" />
                  <a-alert
                    v-if="info.needValidation"
                    :message="
                      $t('profil.nameChangeRequest') +
                      ' ' +
                      moment(info.needValidation.date).format('LL')
                    "
                    type="warning"
                    class="mb-3"
                    :class="{ 'rtl-direction': $i18n.locale === 'ar-AR' }"
                    :show-icon="$i18n.locale !== 'ar-AR'"
                  >
                    <div
                      slot="description"
                      class="name-changes-alert"
                      :class="{ 'rtl-direction': $i18n.locale === 'ar-AR' }"
                    >
                      <template v-if="info.needValidation.firstName">
                        <div>
                          <a-icon
                            :type="
                              $i18n.locale === 'ar-AR'
                                ? 'arrow-left'
                                : 'arrow-right'
                            "
                            class="mx-2"
                          />
                          <span>{{ $t("profil.firstNameChangeRequest") }}</span>
                          <strong
                            :class="$i18n.locale === 'ar-AR' ? 'mr-1' : 'ml-1'"
                            >{{ info.firstName }}</strong
                          >
                          <span class="mx-2">{{ $t("profil.to") }}</span>
                          <strong>{{ info.needValidation.firstName }}</strong>
                          <span class="mx-2">{{
                            $t("profil.requestedBy")
                          }}</span>
                          <a-tag color="blue">
                            {{
                              $t(
                                info.needValidation.requestedBy &&
                                  info.needValidation.requestedBy.firstName ===
                                    "parent"
                                  ? "inscription.parent"
                                  : "profil.student"
                              )
                            }}</a-tag
                          >
                        </div>
                      </template>
                      <template v-if="info.needValidation.lastName">
                        <div class="mt-1">
                          <a-icon
                            :type="
                              $i18n.locale === 'ar-AR'
                                ? 'arrow-left'
                                : 'arrow-right'
                            "
                            class="mx-2"
                          />
                          <span>{{ $t("profil.lastNameChangeRequest") }}</span>
                          <strong
                            :class="$i18n.locale === 'ar-AR' ? 'mr-1' : 'ml-1'"
                            >{{ info.lastName }}</strong
                          >
                          <span class="mx-2">{{ $t("profil.to") }}</span>
                          <strong>{{ info.needValidation.lastName }}</strong>
                          <span class="mx-2">{{
                            $t("profil.requestedBy")
                          }}</span>
                          <a-tag color="blue">
                            {{
                              $t(
                                info.needValidation.requestedBy &&
                                  info.needValidation.requestedBy.lastName ===
                                    "parent"
                                  ? "inscription.parent"
                                  : "profil.student"
                              )
                            }}</a-tag
                          >
                        </div>
                      </template>
                    </div>
                  </a-alert>
                  <a-form
                    :form="form"
                    @submit="updateStudent"
                    v-if="activeKey === '1'"
                  >
                    <div class="row mb-3">
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.prenom')" class="mb-0">
                          <a-input
                            :placeholder="$t('profil.prenom')"
                            :readOnly="
                              !!(
                                info.needValidation &&
                                info.needValidation.firstName
                              )
                            "
                            v-decorator="[
                              'firstName',
                              {
                                initialValue:
                                  info.needValidation &&
                                  info.needValidation.firstName
                                    ? info.needValidation.firstName
                                    : info.firstName,
                                rules: [
                                  {
                                    required: true,
                                    message: $t('requis.prenom'),
                                  },
                                ],
                              },
                            ]"
                          >
                            <template
                              v-if="
                                info.needValidation &&
                                info.needValidation.firstName
                              "
                              slot="suffix"
                            >
                              <a-tooltip :title="$t('profil.approuver')">
                                <a-icon
                                  type="check"
                                  class="text-success mr-1 clickable-icon"
                                  @click="
                                    requestNameChange('firstName', 'approve')
                                  "
                                />
                              </a-tooltip>
                              <a-tooltip :title="$t('profil.rejeter')">
                                <a-icon
                                  type="close"
                                  class="text-danger clickable-icon"
                                  @click="
                                    requestNameChange('firstName', 'reject')
                                  "
                                />
                              </a-tooltip>
                            </template>
                          </a-input>
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.middleName')" class="mb-0">
                          <a-input
                            :placeholder="$t('profil.middleName')"
                            v-decorator="[
                              'middleName',
                              {
                                initialValue: info.middleName,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.nom')" class="mb-0">
                          <a-input
                            :placeholder="$t('profil.nom')"
                            :readOnly="
                              !!(
                                info.needValidation &&
                                info.needValidation.lastName
                              )
                            "
                            v-decorator="[
                              'lastName',
                              {
                                initialValue:
                                  info.needValidation &&
                                  info.needValidation.lastName
                                    ? info.needValidation.lastName
                                    : info.lastName,
                                rules: [
                                  {
                                    required: true,
                                    message: $t('requis.nom'),
                                  },
                                ],
                              },
                            ]"
                          >
                            <template
                              v-if="
                                info.needValidation &&
                                info.needValidation.lastName
                              "
                              slot="suffix"
                            >
                              <a-tooltip :title="$t('profil.approuver')">
                                <a-icon
                                  type="check"
                                  class="text-success mr-1 clickable-icon"
                                  @click="
                                    requestNameChange('lastName', 'approve')
                                  "
                                />
                              </a-tooltip>
                              <a-tooltip :title="$t('profil.rejeter')">
                                <a-icon
                                  type="close"
                                  class="text-danger clickable-icon"
                                  @click="
                                    requestNameChange('lastName', 'reject')
                                  "
                                />
                              </a-tooltip>
                            </template>
                          </a-input>
                        </a-form-item>
                      </div>
                    </div>

                    <!--french full name-->
                    <div class="row" v-if="!countryIsKE">
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.prenomFr')">
                          <a-input
                            :placeholder="$t('profil.prenomFr')"
                            v-decorator="[
                              'firstNameFr',
                              {
                                initialValue: info.firstNameFr,
                              },
                            ]"
                          >
                          </a-input>
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.middleNameFr')">
                          <a-input
                            :placeholder="$t('profil.middleNameFr')"
                            v-decorator="[
                              'middleNameFr',
                              {
                                initialValue: info.middleNameFr,
                              },
                            ]"
                          >
                          </a-input>
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.nomFr')">
                          <a-input
                            :placeholder="$t('profil.nomFr')"
                            v-decorator="[
                              'lastNameFr',
                              {
                                initialValue: info.lastNameFr,
                              },
                            ]"
                          >
                          </a-input>
                        </a-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.sexe')" class="mb-0">
                          <a-radio-group
                            style="width: 100%"
                            button-style="solid"
                            v-decorator="[
                              'gender',
                              {
                                initialValue: info.gender,
                                rules: [
                                  {
                                    required: true,
                                    message: $t('requis.genre'),
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-radio-button value="male" style="width: 50%">
                              {{ $t("profil.garcon") }}</a-radio-button
                            >
                            <a-radio-button value="female" style="width: 50%">
                              {{ $t("profil.fille") }}
                            </a-radio-button>
                          </a-radio-group>
                        </a-form-item>
                      </div>
                      <div class="col-lg-4" v-if="countryIsKE">
                        <a-form-item :label="$t('profil.nemisNumber')">
                          <a-input
                            :placeholder="$t('profil.nemisNumber')"
                            v-decorator="[
                              'nemisNumber',
                              {
                                initialValue: info.nemisNumber,
                              },
                            ]"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4" v-else>
                        <a-form-item :label="$t('liste.identifiantUnique')">
                          <a-input
                            :placeholder="$t('liste.identifiantUnique')"
                            v-decorator="[
                              'uniqueId',
                              {
                                initialValue: info.uniqueId,
                              },
                            ]"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.nombreInscriptions')">
                          <a-input
                            type="number"
                            v-decorator="[
                              'info.personalInfo.numberOfRegistrations',
                              {
                                initialValue:
                                  info.personalInfo.numberOfRegistrations,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.nombreInscriptions')"
                          />
                        </a-form-item>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.dateNaissance')">
                          <a-date-picker
                            style="width: 100%"
                            format="DD/MM/YYYY"
                            v-decorator="[
                              'birthDay',
                              {
                                initialValue: moment(info.BirthDate),
                                rules: [
                                  {
                                    required: true,
                                    message: $t('requis.dateNaissance'),
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.birthPlace')">
                          <a-input
                            v-decorator="[
                              'birthPlace',
                              {
                                initialValue: info.birthPlace,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.birthPlace')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('inscription.parent')">
                          <a-select
                            show-search
                            :loading="loadingParentChange"
                            option-filter-prop="children"
                            :disabled="status != 'active'"
                            :filter-option="filterOption"
                            :placeholder="$t('sms.listeParents')"
                            @change="handleParentChange"
                            :value="info.parent ? info.parent._id : undefined"
                          >
                            <a-select-option
                              :value="item.id"
                              v-for="item in parentsList"
                              :key="item.id"
                            >
                              {{ item.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.classe')">
                          <a-select
                            show-search
                            option-filter-prop="children"
                            :disabled="
                              changeClassRoomDisable || status != 'active'
                            "
                            :loading="changeClassRoomDisable"
                            :filter-option="filterOption"
                            :placeholder="$t('liste.classes')"
                            @change="showRepReductionModal"
                            v-decorator="[
                              'classRoom',
                              {
                                initialValue: info.classRoom
                                  ? info.classRoom._id
                                  : '',
                              },
                            ]"
                          >
                            <a-select-opt-group
                              v-for="group in classRoomsGroupedByLevel"
                              :key="group.key"
                              :label="group.label"
                            >
                              <a-select-option
                                :value="item.id"
                                v-for="item in group.classrooms"
                                :key="item.id"
                              >
                                {{ item.name }}
                                <a-tag
                                  v-if="item.classroomType === 'affectation'"
                                  color="orange"
                                  class="ml-2"
                                >
                                  {{ $t("etablissement.niveauAffectation") }}
                                </a-tag>
                              </a-select-option>
                            </a-select-opt-group>
                          </a-select>
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.adresse')">
                          <a-input
                            v-decorator="[
                              'adress',
                              {
                                initialValue: info.adress,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.adresse')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('profil.tel')">
                          <phone-number-input
                            :default-country-code="countryIsKE ? 'KE' : 'TN'"
                            v-decorator="[
                              'phone',
                              {
                                initialValue: info.phone,
                                rules: [{ required: false }],
                              },
                            ]"
                          />
                        </a-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <a-form-item :label="$t('profil.postalAddress')">
                          <a-input
                            v-decorator="[
                              'postalAddress',
                              {
                                initialValue: info.postalAddress,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.postalAddress')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('profil.physicalAddress')">
                          <a-input
                            v-decorator="[
                              'physicalAddress',
                              {
                                initialValue: info.physicalAddress,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.physicalAddress')"
                          />
                        </a-form-item>
                      </div>
                    </div>
                    <template v-if="countryIsKE">
                      <div class="row">
                        <div class="col-lg-4">
                          <a-form-item :label="$t('profil.birthCertificate')">
                            <a-upload
                              v-if="!info.birthCertificate"
                              :before-upload="beforeUploadBirthCertificate"
                              :file-list="birthCertificateFileList"
                              :customRequest="addToBirthCertificateList"
                              @change="handleChangeBirthCertificate"
                              v-decorator="[
                                'birthCertificate',
                                {
                                  rules: [
                                    {
                                      required: shouldRequireBirthCertificate,
                                      message: $t('requis.birthCertificate') || 'Birth certificate is required for Grade 3 and above',
                                    },
                                  ],
                                },
                              ]"
                            >
                              <a-button>
                                <a-icon type="upload" /> {{ $t('recette.uploadFile')  }}
                              </a-button>
                            </a-upload>
                            <div v-else>
                              <a-button
                                :href="settings.resourcesUrl.replace('FILE_PATH', info.birthCertificate)"
                                target="_blank"
                                icon="file"
                              >
                                {{ $t('recette.viewFile') }}
                              </a-button>
                              <a-button
                                @click="removeBirthCertificate"
                                icon="delete"
                                type="danger"
                                class="ml-2"
                              >
                                {{ $t('action.supprimer') }}
                              </a-button>
                            </div>
                          </a-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <a-form-item :label="$t('profil.saccoName') ">
                            <a-input
                              v-decorator="[
                                'saccoName',
                                {
                                  initialValue: info.sacco && info.sacco.name,
                                },
                              ]"
                              :placeholder="$t('profil.saccoName') "
                            />
                          </a-form-item>
                        </div>
                        <div class="col-lg-6">
                          <a-form-item :label="$t('profil.saccoBankName') ">
                            <a-input
                              v-decorator="[
                                'saccoBankName',
                                {
                                  initialValue: info.sacco && info.sacco.bankDetails && info.sacco.bankDetails.name,
                                },
                              ]"
                              :placeholder="$t('profil.saccoBankName') "
                            />
                          </a-form-item>
                        </div>
                      </div>
                    </template>
                    <div class="row">
                      <a-divider class="my-0">{{
                        $t("liste.addFiles")
                      }}</a-divider>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('liste.addFiles')">
                          <a-upload-dragger
                            multiple
                            :before-upload="beforeUploadStudentFiles"
                            :remove="removeFile"
                            :fileList="studentFiles"
                            :customRequest="addToStudentfileList"
                            @change="handleChangeStudentFiles"
                          >
                            <p class="ant-upload-drag-icon">
                              <a-icon type="inbox" />
                            </p>
                            <p class="ant-upload-text">
                              {{ $t("etablissement.clickOrDragToUpload") }}
                            </p>
                          </a-upload-dragger>
                        </a-form-item>
                      </div>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('liste.studentFiles')">
                          <div class="card p-2" style="min-height: 130px">
                            <div v-if="info.files && info.files.length > 0">
                              <div
                                v-for="file in info.files"
                                :key="file"
                                style="width: 100%"
                              >
                                <a-popconfirm
                                  :title="$t('requis.supp')"
                                  @confirm="() => removeStudentFile(file)"
                                >
                                  <a-button
                                    type="dashed"
                                    shape="circle"
                                    icon="delete"
                                  ></a-button>
                                </a-popconfirm>
                                <a-button
                                  :href="
                                    settings.resourcesUrl.replace(
                                      'FILE_PATH',
                                      file
                                    )
                                  "
                                  target="_blank"
                                  style="text-align: left; width: 80%"
                                  class="mb-1 ml-2"
                                  icon="file"
                                >
                                  {{ getFileName(file) }}
                                </a-button>
                              </div>
                            </div>
                            <div v-else>
                              <a-empty />
                            </div>
                          </div>
                        </a-form-item>
                      </div>
                    </div>

                    <div class="row">
                      <a-divider class="my-0">{{
                        $t("profil.notes")
                      }}</a-divider>
                      <div class="col-lg-12">
                        <a-form-item :label="$t('profil.notes')">
                          <a-input
                            type="textarea"
                            v-decorator="[
                              'notes',
                              {
                                initialValue: info.notes,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.notes')"
                          />
                        </a-form-item>
                      </div>

                      <div class="col-lg-12">
                        <a-form-item
                          :label="$t('autorisation.medicalNote')"
                          :help="$t('autorisation.medicalNoteContext')"
                        >
                          <a-input
                            type="textarea"
                            v-decorator="[
                              'medicalNotes',
                              {
                                initialValue: info.medicalNotes,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('autorisation.medicalNote')"
                          />
                        </a-form-item>
                      </div>

                      <div class="col-lg-12">
                        <a-form-item
                          :label="$t('autorisation.noteForTeachers')"
                          :help="$t('autorisation.noteForTeachersContext')"
                        >
                          <a-input
                            type="textarea"
                            v-decorator="[
                              'noteForTeachers',
                              {
                                initialValue: info.noteForTeachers || '',
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('autorisation.noteForTeachers')"
                          />
                        </a-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <a-divider>{{ $t("profil.healthInformation") }}</a-divider>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('profil.bloodType')">
                          <a-select
                            v-decorator="[
                              'healthInfo.bloodType',
                              {
                                initialValue: info.healthInfo && info.healthInfo.bloodType,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.bloodType')"
                          >
                            <a-select-option value="A+">A+</a-select-option>
                            <a-select-option value="A-">A-</a-select-option>
                            <a-select-option value="B+">B+</a-select-option>
                            <a-select-option value="B-">B-</a-select-option>
                            <a-select-option value="AB+">AB+</a-select-option>
                            <a-select-option value="AB-">AB-</a-select-option>
                            <a-select-option value="O+">O+</a-select-option>
                            <a-select-option value="O-">O-</a-select-option>
                            <a-select-option value="Unknown">{{ $t('profil.unknown') }}</a-select-option>
                          </a-select>
                        </a-form-item>
                      </div>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('profil.medicalCondition')">
                          <a-input
                            v-decorator="[
                              'healthInfo.medicalCondition',
                              {
                                initialValue: info.healthInfo && info.healthInfo.medicalCondition,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.medicalCondition')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('profil.allergies')">
                          <a-input
                            v-decorator="[
                              'healthInfo.allergies',
                              {
                                initialValue: info.healthInfo && info.healthInfo.allergies,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.allergies')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-6">
                        <a-form-item :label="$t('profil.parentNoteOnAllergies')">
                          <a-input
                            type="textarea"
                            v-decorator="[
                              'healthInfo.parentNoteOnAllergies',
                              {
                                initialValue: info.healthInfo && info.healthInfo.parentNoteOnAllergies,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('profil.parentNoteOnAllergies')"
                          />
                        </a-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <a-divider>{{ $t("calender.other") }}</a-divider>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.dateEntree')">
                          <a-date-picker
                            style="width: 100%"
                            format="DD/MM/YYYY"
                            v-decorator="[
                              'info.personalInfo.entryDate',
                              {
                                initialValue: info.personalInfo.entryDate,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.dateEntree')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.dateSortie')">
                          <a-date-picker
                            style="width: 100%"
                            format="DD/MM/YYYY"
                            v-decorator="[
                              'info.personalInfo.exitDate',
                              {
                                initialValue: info.personalInfo.exitDate,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.dateSortie')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.motifSortie')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.exitReason',
                              {
                                initialValue: info.personalInfo.exitReason,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.motifSortie')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.attendance')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.attendance',
                              {
                                initialValue: info.personalInfo.attendance,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.attendance')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.behavior')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.behavior',
                              {
                                initialValue: info.personalInfo.behavior,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.behavior')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.motivation')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.effort',
                              {
                                initialValue: info.personalInfo.effort,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.motivation')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.accompanyingDocuments')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.attachedDocs',
                              {
                                initialValue: info.personalInfo.attachedDocs,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.accompanyingDocuments')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.previousInstitution')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.previousInstitution',
                              {
                                initialValue:
                                  info.personalInfo.previousInstitution,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.previousInstitution')"
                          />
                        </a-form-item>
                      </div>
                      <div class="col-lg-4">
                        <a-form-item :label="$t('liste.secondarySchool')">
                          <a-input
                            v-decorator="[
                              'info.personalInfo.secondarySchool',
                              {
                                initialValue: info.personalInfo.secondarySchool,
                                rules: [
                                  {
                                    required: false,
                                  },
                                ],
                              },
                            ]"
                            :placeholder="$t('liste.secondarySchool')"
                          />
                        </a-form-item>
                      </div>
                    </div>

                    <div class="form-actions mb-0">
                      <a-progress
                        :stroke-color="{
                          from: '#108ee9',
                          to: '#87d068',
                        }"
                        v-if="progress.value > 0"
                        :percent="progress.value"
                        status="active mb-4"
                      />
                    </div>
                    <div class="row">
                      <div class="col d-flex" v-if="countryIsTN">
                        <a-dropdown>
                          <a-menu
                            slot="overlay"
                            @click="generateFichePersonnelPDF"
                          >
                            <a-menu-item key="wihtPhoto" va>
                              Avec photo de l'élève
                            </a-menu-item>
                            <a-menu-item key="withoutPhoto">
                              Sans photo de l'élève
                            </a-menu-item>
                          </a-menu>
                          <a-button>
                            <a-icon type="file-pdf" />
                            {{ $t("liste.fichePersonnel") }}
                          </a-button>
                        </a-dropdown>
                      </div>
                      <div class="col d-flex justify-content-end">
                        <a-popconfirm
                          v-if="
                            verifyRoleAccess(['all', 'annulation_eleve']) &&
                            info.classRoom &&
                            status == 'active'
                          "
                          :title="$t('requis.annu')"
                          @confirm="() => onCancelInscription()"
                          :disabled="loadingUpdateStudent"
                        >
                          <a-button
                            type="danger"
                            icon="user-delete"
                            :disabled="loadingUpdateStudent"
                          >
                            {{ $t("profil.annulerInscri") }}
                          </a-button>
                        </a-popconfirm>
                        <a-button
                          v-else
                          type="danger"
                          icon="user-delete"
                          :disabled="true"
                        >
                          {{ $t("profil.annulerInscri") }}
                        </a-button>
                        <a-button
                          class="ml-2"
                          type="primary"
                          htmlType="submit"
                          :disabled="status != 'active' || loadingUpdateStudent"
                          :loading="loadingUpdateStudent"
                        >
                          {{ $t("action.enregistrer") }}
                        </a-button>
                      </div>
                    </div>
                  </a-form>
                </a-collapse-panel>
              </a-collapse>
              <!--Paiement scolarité tab-->

              <div v-if="activeKey === '2' && info.classRoom">
                <scolartiePayments :studentId="studentId" />
              </div>
              <!--Paiements activités tab-->

              <div v-if="activeKey === '3'">
                <activityPayments :studentId="studentId" />
              </div>
              <!--Liste des réglements tab-->
              <div v-if="activeKey === '4'">
                <invoices
                  :parentId="info.parent._id"
                  :studentId="studentId"
                ></invoices>
                <!-- <h4>Mode de présentation</h4>

                <a-tabs default-active-key="1">
                  <a-tab-pane key="1" tab="Paiements multiples" force-render>
                    <multi-liste-reglement :parentId="info.parent._id" :studentId="studentId"></multi-liste-reglement>
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="Factures et reçus" force-render>
                    <list-reglement :parentId="info.parent._id" :studentId="studentId"></list-reglement>
                  </a-tab-pane>
                  <a-tab-pane key="3" tab="Factures et reçus" force-render>

                  </a-tab-pane>
                </a-tabs>-->
              </div>
              <!--notes tab-->
              <div v-if="activeKey === '7'">
                <bulletin
                  :studentId="studentId"
                  :classRoomId="info.classRoom ? info.classRoom._id : ''"
                  :classRoomLevel="info.classRoom ? info.classRoom.level : ''"
                  :studentDetails="{
                    fullName: info.firstName + (info.middleName ? ' ' + info.middleName : '') + ' ' + info.lastName,
                    gender: info.gender,
                  }"
                >
                </bulletin>
              </div>
              <!--assiduité tab-->

              <div v-if="activeKey === '8'">
                <assiduite
                  :studentName="this.info.firstName + (this.info.middleName ? ' ' + this.info.middleName : '') + ' ' + this.info.lastName"
                  :studentId="studentId"
                  :classRoomId="info.classRoom ? info.classRoom._id : ''"
                  :classLevel="info.classRoom ? info.classRoom.level : ''"
                ></assiduite>
              </div>
              <!--reduction-de-base tab-->

              <div v-if="activeKey === '9'">
                <reduction-de-base :studentId="studentId"></reduction-de-base>
              </div>
              <!--invoice builder tab-->
              <div v-if="activeKey === '10'">
                <invoiceBuilder
                  class="mt-2"
                  :idParent="info.parent._id"
                  :student="info"
                  @reload="reload"
                  :classroomName="info.classRoom ? info.classRoom.name : ''"
                ></invoiceBuilder>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      v-model="visibleRepReductionModal"
      @cancel="closeRepReductionModal"
      :width="700"
      :footer="false"
    >
      <div class="row">
        <div class="col-lg-3">
          <h6 for="">{{ $t("inscription.fraisInscri") + " (dt)" }}</h6>
          <p>{{ selectedClassRoom.inscription }}</p>
        </div>
        <div
          @click="changeModeP('M')"
          :class="[
            'col-lg-4',
            'mr-2',
            'pt-2',
            modePaiement === 'M' ? 'custom-border-active' : 'custom-border',
          ]"
        >
          <h6 for="">{{ $t("inscription.fraisMensuel") + " (dt)" }}</h6>
          <p>{{ selectedClassRoom.monthly }}</p>
        </div>
        <div
          @click="changeModeP('T')"
          :class="[
            'col-lg-4',
            'pt-2',
            modePaiement === 'T' ? 'custom-border-active' : 'custom-border',
          ]"
          v-if="selectedClassRoom.tranches"
        >
          <h6 for="">{{ $t('inscription.fraisDesTranches') }} (dt)</h6>
          <li v-for="t in selectedClassRoom.tranches" :key="t.trancheNumber">
            {{ $t('inscription.tranche') + " " + t.trancheNumber + " : " + t.amount }}
          </li>
        </div>
      </div>
      <a-divider />
      <a-alert
        class="mt-2"
        :message="
          $t('inscription.modePaiementSelectionne') + ' ' +
          (modePaiement === 'T' ? $t('inscription.parTranches') : $t('inscription.mensuelle'))
        "
        type="info"
        show-icon
      />

      <div class="form-actions mt-0">
        <a-button
          style="width: 150px"
          type="primary"
          @click="initNewInscription"
          :loading="loadingClassroomChange"
          class="mr-3"
        >
          {{ $t("action.enregistrer") }}
        </a-button>
        <a-button
          key="back"
          @click="closeRepReductionModal"
          :disabled="loadingClassroomChange"
        >
          {{ $t("action.annuler") }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import moment from "moment";
import apiClient from "@/services/axios";
import { showApiError } from "@/utilities/showApiError";
import ProfileCard from "./components/profileCard/index";
import controlParentale from "./components/controlParental/index";
import studentCredentials from "./components/studentCrendentials/index";
import assiduite from "./components/assiduite/index";
import ParentExpand from "./components/ParentExpand.vue";
import invoiceBuilder from "./components/invoiceBuilder";
import { mapState, mapActions, mapGetters } from "vuex";
import ListReglement from "./components/listeReglement/listReglement.vue";
import Invoices from "./components/listeReglement/invoices";
import reductionDeBase from "./components/reductionDeBase";
import KitList5 from "@/components/kit/widgets/Lists/5/index";
import bulletin from "./components/bulletin";
import PaymentStatus from "@/components/status/paymentStatus.vue";
const { AwesomeQR } = require("awesome-qr");
import axios from "axios";
import scolartiePayments from "./components/scolartiePayments";
import activityPayments from "./components/activityPayments";

import JsPDF from "jspdf";
import VueQr from "vue-qr";
import { getRangeMonthsSY } from "@/utilities/settings";
import { getSchoolTypeLabel } from "@/utilities/buildingTypeLabel";
import { getLevels } from "@/config/LevelConstants";
import { uploadFilesToS3 } from "@/services/uploadService";
import _ from "lodash";

const frMonths = {};
const months = moment.months();
for (let i = 0; i < months.length; i++) frMonths[i + 1] = months[i];

function parentFormater(parent) {
  return {
    name: parent.guardian?.firstName
      ? parent.guardian.firstName + " " + parent.guardian?.lastName
      : parent.father?.firstName +
        " " +
        parent.father?.lastName +
        " et " +
        parent.mother?.firstName +
        " " +
        parent.mother?.lastName,
    id: parent._id,
    status: parent.status,
  };
}
function flattenToDotNotation(obj, prefix = "") {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    const fullKey = prefix ? `${prefix}.${key}` : key;

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(result, flattenToDotNotation(value, fullKey));
    } else {
      result[fullKey] = value;
    }
  }

  return result;
}

export default {
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["btnAccessGetter"]),
    countryIsTN() {
      const building = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0] || {};
      return building.countryCode == "TN";
    },
    countryIsKE() {
      const building = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0] || {};
      return building.countryCode == "KE";
    },
    activeBuilding() {
      return (
        (this.user.building || []).find(
          (el) => el.dbName == this.settings.activeBuilding
        ) || {}
      );
    },
    levelLabels() {
      return getLevels(
        this.$t.bind(this),
        this.activeBuilding.type || [],
        this.activeBuilding.countryCode
      );
    },
    classRoomsGroupedByLevel() {
      const active = (this.classRoomList || []).filter(
        (e) => e.status === "active"
      );
      const groupsMap = {};

      active.forEach((classroom) => {
        const rawLevel = classroom.level;
        const hasLevel =
          rawLevel !== undefined &&
          rawLevel !== null &&
          rawLevel !== "" &&
          !Number.isNaN(Number(rawLevel));
        const key = hasLevel ? String(rawLevel) : "other";
        if (!groupsMap[key]) {
          groupsMap[key] = {
            key,
            label: hasLevel
              ? this.levelLabels[key] || `${this.$t("etablissement.niveau") || "Niveau"} ${key}`
              : this.$t("scolarite.other"),
            sortLevel: hasLevel ? Number(rawLevel) : Number.POSITIVE_INFINITY,
            classrooms: [],
          };
        }
        groupsMap[key].classrooms.push(classroom);
      });

      return Object.values(groupsMap)
        .map((group) => ({
          ...group,
          classrooms: group.classrooms.slice().sort((a, b) => {
            // Affectation first within the level, then alphabetical.
            const aAff = a.classroomType === "affectation" ? 0 : 1;
            const bAff = b.classroomType === "affectation" ? 0 : 1;
            if (aAff !== bAff) return aAff - bAff;
            return String(a.name || "").localeCompare(String(b.name || ""));
          }),
        }))
        .sort((a, b) => a.sortLevel - b.sortLevel);
    },
    shouldRequireBirthCertificate() {
      if (!this.countryIsKE) return false;
      if (this.info.classRoom && this.info.classRoom.level !== undefined) {
        return this.info.classRoom.level >= 3;
      }
      return false;
    },
    getBuilding() {
      return (
        this.settings.image.filter(
          (img) => img.db == this.settings.activeBuilding
        )[0] || {}
      );
    },
    currentStudentHash() {
      if (
        Object.keys(this.loginHashes).length > 0 &&
        this.loginHashes[this.studentId]
      ) {
        return this.loginHashes[this.studentId];
      }
      return "";
    },
  },
  components: {
    ProfileCard,
    controlParentale,
    studentCredentials,
    ListReglement,
    Invoices,
    KitList5,
    VueQr,
    bulletin,
    assiduite,
    PaymentStatus,
    reductionDeBase,
    scolartiePayments,
    activityPayments,
    ParentExpand,
    invoiceBuilder,
  },
  beforeMount() {
    this.form = this.$form.createForm(this, { name: "studentForm" });
    let qrDataDetail =
      this.studentId +
      "." +
      this.settings.activeBuilding +
      "." +
      this.settings.activeSchoolarYear +
      "." +
      this.settings.base_url;
    this.qrData = btoa(qrDataDetail);
  },
  async created() {
    this.gtagPageView("Informations");

    const navigate = this.$route.query.navigate;
    if (navigate && ["1", "2", "3"].includes(navigate))
      this.activeKey = navigate;
    else this.activeKey = "1";
    await apiClient
      .post("/classrooms/filter", {
        query: { includeAffectation: true },
        aggregation: [
          {
            $addFields: {
              id: "$_id",
            },
          },
          {
            $project: {
              teachers: 0,
            },
          },
        ],
      })
      .then((res) => {
        this.classRoomList = res.data;
      });
    await apiClient
      .post("/parents/filter", {
        query: { status: "active" },
        aggregation: {
          $project: {
            _id: 1,
            father: { firstName: 1, lastName: 1 },
            mother: { firstName: 1, lastName: 1 },
            guardian: { firstName: 1, lastName: 1 },
            status: 1,
          },
        },
      })
      .then((res) => {
        this.parentsList = res.data.map((item) => parentFormater(item));
      });
    await apiClient
      .post(`/students/filter`, {
        query: {
          _id: this.studentId,
        },
        aggregation: [
          {
            $set: {
              classRoom: {
                $toObjectId: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
              },
            },
          },
          {
            $lookup: {
              from: "parents",
              localField: "parent",
              foreignField: "_id",
              as: "parent",
            },
          },
          {
            $lookup: {
              from: "classrooms",
              localField: "classRoom",
              foreignField: "_id",
              as: "classRoom",
            },
          },
          {
            $unwind: {
              path: "$parent",
              preserveNullAndEmptyArrays: true,
            },
          },
          {
            $unwind: {
              path: "$classRoom",
              preserveNullAndEmptyArrays: true,
            },
          },
          {
            $lookup: {
              from: "parentlogins",
              localField: "parent.father.login",
              foreignField: "_id",
              as: "parent.father.login",
            },
          },
          {
            $unwind: {
              path: "$parent.father.login",
              preserveNullAndEmptyArrays: true,
            },
          },
          {
            $lookup: {
              from: "parentlogins",
              localField: "parent.mother.login",
              foreignField: "_id",
              as: "parent.mother.login",
            },
          },
          {
            $unwind: {
              path: "$parent.mother.login",
              preserveNullAndEmptyArrays: true,
            },
          },
          {
            $lookup: {
              from: "parentlogins",
              localField: "parent.guardian.login",
              foreignField: "_id",
              as: "parent.guardian.login",
            },
          },
          {
            $unwind: {
              path: "$parent.guardian.login",
              preserveNullAndEmptyArrays: true,
            },
          },
          {
            $project: {
              classRoom: 1,
              parent: {
                _id: 1,
                photoMediaPromotionalConsent: 1,
                father: {
                  firstName: 1,
                  lastName: 1,
                  phone: 1,
                  job: 1,
                  adress: 1,
                  email: 1,
                  login: {
                    _id: 1,
                    userName: 1,
                    mfa: {
                      enabled: 1,
                      method: 1,
                    },
                  },
                  status: 1,
                },
                mother: {
                  firstName: 1,
                  lastName: 1,
                  phone: 1,
                  job: 1,
                  adress: 1,
                  email: 1,
                  login: {
                    _id: 1,
                    userName: 1,
                    mfa: {
                      enabled: 1,
                      method: 1,
                    },
                  },
                  status: 1,
                },
                guardian: {
                  firstName: 1,
                  lastName: 1,
                  phone: 1,
                  job: 1,
                  adress: 1,
                  email: 1,
                  login: {
                    _id: 1,
                    userName: 1,
                    mfa: {
                      enabled: 1,
                      method: 1,
                    },
                  },
                  status: 1,
                },
                status: 1,
              },
              adress: 1,
              postalAddress: 1,
              physicalAddress: 1,
              BirthDate: 1,
              birthPlace: 1,
              firstName: 1,
              middleName: 1,
              lastName: 1,
              firstNameFr: 1,
              middleNameFr: 1,
              lastNameFr: 1,
              gender: 1,
              phone: 1,
              medicalNotes: 1,
              noteForTeachers: 1,
              healthInfo: 1,
              photo: 1,
              ps: 1,
              userName: 1,
              uniqueId: 1,
              schoolarYearsHistory: 1,
              createdAt: 1,
              updatedAt: 1,
              notes: 1,
              files: 1,
              status: 1,
              reasonArchive: 1,
              needValidation: 1,
              personalInfo: 1,
              nemisNumber: 1,
              birthCertificate: 1,
              sacco: 1,
            },
          },
        ],
      })
      .then(async (res) => {
        this.info = res.data[0];
        if (!this.info.personalInfo) this.info.personalInfo = {};
        if (!this.info.healthInfo) this.info.healthInfo = {};
        this.status = this.info.status;
        if (!this.info.files) this.$set(this.info, "files", []);
        if (!this.info.noteForTeachers)
          this.$set(this.info, "noteForTeachers", "");
        this.info.parent = this.info.parent;
        this.info.ps = "";
        const classIds = [];
        this.classRoomList.forEach((e) => {
          if (e.status === "active") classIds.push(e._id);
        });
        // Soft-deleted / missing classrooms are treated as no placement so the
        // class select does not show a raw ObjectId for an inactive option.
        if (
          !this.info.classRoom ||
          this.info.classRoom.status !== "active" ||
          !classIds.includes(this.info.classRoom._id)
        )
          this.info.classRoom = null;
        this.leading = false;
        await this.requestLoginHash(this.info.parent._id);

        // upsert parent if not found in the parentsList
        if (!this.parentsList.find((p) => p.id == this.info.parent._id)) {
          this.parentsList.push(parentFormater(this.info.parent));
        }
      })
      .catch((e) => {
        console.log(e);
      });

    const schoolarYearsHistory = this.info.schoolarYearsHistory;

    const classes = Object.values(schoolarYearsHistory);

    // for histories
    apiClient
      .post("/classrooms/classnames", {
        classrooms: classes,
      })
      .then((res) => {
        const names = res.data;
        for (const schoolarId of Object.keys(schoolarYearsHistory)) {
          let { start, end } = this.settings.schoolarYears.find(
            (el) => el._id == schoolarId
          );

          start = moment(start).format("MM-YYYY");
          end = moment(end).format("MM-YYYY");

          const classroom = names.find(
            (c) => c._id == schoolarYearsHistory[schoolarId]
          );
          this.schoolHistory.push({
            _id: schoolarId,
            classroomName: classroom.name,
            year: start + " / " + end,
          });
        }
      });
  },
  props: {
    studentId: {
      required: true,
    },
  },
  data: function () {
    return {
      loginHashes: {},
      loadingClassroomChange: false,
      selectedClassRoom: {},
      visibleRepReductionModal: false,
      loadingBadge: false,
      loadingParentChange: false,
      parentsList: [],
      allDataPayement: [],
      progress: { value: 0 },
      activeCollapseKey: ["3"],
      status: "",
      schoolHistory: [],
      currentMonthName: moment().format("MMMM"),
      qrData: "",
      visiblePaymentStatus: false,
      loadingPaymentStatus: false,
      loadingPaymentStatusPdf: false,
      loadingUpdateStudent: false,
      paymentStatus: [],
      loadingActPay: true,
      qrDataImage: "",
      tempBulletinFile: null,
      fileList2: [],
      fileList1: [],
      fileList3: [],
      studentFiles: [],
      updateDrawer: false,
      changeClassRoomDisable: false,
      ActivityPaymentModal: {},
      ClassRoomPaymentModal: {},
      frMonths,
      visibleModal: false,
      visibleClassModal: false,
      classRoomPayment: [],
      fileList: [],
      studentFileList: [],
      studentFileListToDelete: [],
      birthCertificateFileList: [],
      birthCertificateFile: null,
      birthCertificateToDelete: false,
      leading: true,
      info: {},
      activeKey: null,
      form: this.$form.createForm(this),
      classRoomList: [],
      previewImage: { file: null, visible: false },
      moment,
      data: [],
      columns: [
        {
          title: this.$t("etablissement.designation"),
          dataIndex: "name",
          key: "name",
          scopedSlots: {
            customRender: "name",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          sorter: (a, b) => a.name.length - b.name.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("paiement.mois"),
          dataIndex: "months",
          key: "months",
          scopedSlots: {
            customRender: "months",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
        },
        {
          title: this.$t("profil.etat"),
          dataIndex: "paymentStatus",
          key: "paymentStatus",
          scopedSlots: {
            customRender: "paymentStatus",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          scopedSlots: { customRender: "paymentStatus" },

          sorter: (a, b) => a.status.length - b.status.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("profil.consulterPaiement"),

          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
      ],
      modePaiement: "M",
    };
  },
  methods: {
    calculateAge: function (date) {
      const birthday = new Date(date);
      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    async requestLoginHash(parentID) {
      try {
        const res = await apiClient.get(
          `/parents/request-login-hash/${parentID}`
        );
        this.loginHashes = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    parentalControlUpdated(parentType, data) {
      this.info.parent[parentType] = _.merge(
        {},
        this.info.parent[parentType],
        data
      );
    },
    parentUpdated(data) {
      this.parentsList = this.parentsList.map((p) => {
        if (p.id == data.id) {
          return parentFormater(data);
        } else return p;
      });
      this.info.parent = _.merge({}, this.info.parent, data);
      this.info.parent._id = data.id;
    },
    changeModeP(v) {
      this.modePaiement = v;
    },
    gtagPageView(name) {
      this.$gtag.pageview({
        page_path: this.$route.path,
        page_location: window.location.href,
        page_title: document.title + " - " + name,
      });
    },
    ...mapActions("settings", ["packHasBtnAccess"]),
    verifyRoleAccess: function (accessRoles) {
      const existing = this.user.access;
      if (existing.all) return true;
      if (
        existing.liste_eleves === true ||
        (existing.liste_eleves &&
          existing.liste_eleves.length > 0 &&
          existing.liste_eleves.find((e) => accessRoles.includes(e)))
      )
        return true;
      else return false;
    },
    verifyTabsAccess: function () {
      const existing = this.user.access;
      if (existing.all) return true;
      if (
        existing.liste_eleves === true ||
        (existing.liste_eleves &&
          existing.liste_eleves.length > 0 &&
          existing.liste_eleves.filter(
            (e) =>
              ![
                "liste_eleves",
                "annulation_eleve",
                "suppression_eleve",
              ].includes(e)
          ).length > 0)
      )
        return true;
      else return false;
    },

    async generatePdf() {
      if (!(await this.packHasBtnAccess("prBadge"))) return;
      this.$gtag.event("Imp eleve badge", {
        event_category: "Impression PDF",
        event_label: "ProfileEleve:qr_code section",
        value: 1,
      });

      this.loadingBadge = true;

      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
        }
      }

      const schoolDetails = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0];

      const schoolName = schoolDetails.ArabicName || schoolDetails.name;

      var doc = new JsPDF("l", "mm", [55, 90]);
      doc.setFont("Amiri");
      var today = new Date();
      const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      };
      doc.setFont("Amiri");
      doc.setFontSize(10);
      let birthDay = new Date(this.info.BirthDate);
      doc.setFont(undefined, "bold");
      doc.text(47, 21, "Nom et prénom: ");
      doc.setFont("Amiri", "normal");
      doc.setFontSize(9);
      doc.text(
        47,
        27,
        this.capitalizeFirstLetter(
          this.info.firstName + (this.info.middleName ? " " + this.info.middleName : "") + " " + this.info.lastName
        )
      );
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text(47, 33, "Date de naissance:");
      doc.setFont("Amiri", "normal");
      doc.text(47, 39, birthDay.toLocaleDateString("fr-FR", options));
      doc.setFontSize(5);
      doc.text(
        52,
        49,
        "Géneré le : " + " " + today.toLocaleDateString("fr-FR", options)
      );

      doc.addImage(this.qrDataImage, "JPEG", 5, 12, 40, 40);
      doc.addImage(imgData, "JPEG", 75, 4, 10, 10);

      doc.setFontSize(13);
      doc.text(schoolName, 46, 10, "center");

      this.loadingBadge = false;

      doc.save(
        "badge_" + this.info.lastName + "_" + this.info.firstName + ".pdf"
      );
    },
    async generateNewBadge() {
      if (!(await this.packHasBtnAccess("prBadgePhoto"))) return;

      this.$gtag.event("Imp eleve badge with photo", {
        event_category: "Impression PDF",
        event_label: "ProfileEleve:qr_code section",
        value: 1,
      });

      this.loadingBadge = true;

      let schoolLogo = null;
      let arrayOfImages = this.settings.image;
      for (var i = 0; i < arrayOfImages.length; i++) {
        if (this.settings.activeBuilding === arrayOfImages[i].db) {
          var imgData = new Image();
          imgData.src = arrayOfImages[i].logo;
          schoolLogo = arrayOfImages[i].logo;
        }
      }

      const schoolDetails = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0];

      const schoolName = schoolDetails.ArabicName || schoolDetails.name;

      const doc = new JsPDF("p", "mm", "a6");

      const backgroundColor = "#81b6f7";
      const lineColor = "#61a6fa";
      const photoColor = "#ffffff";

      const page_width = doc.internal.pageSize.getWidth();
      const page_height = doc.internal.pageSize.getHeight();
      const ctx = doc.context2d;

      doc.setFillColor(backgroundColor);
      doc.setDrawColor(lineColor);

      doc.rect(0, 50, page_width, page_height, "FD");

      doc.setFillColor(photoColor);
      doc.setDrawColor(lineColor);
      doc.setLineWidth(0.6);
      doc.circle(page_width / 2, 50, 20, "FD");

      // draw student photo
      // -------------------------------------------------------------
      const studentPhoto = new Image();
      if (this.info.photo)
        studentPhoto.src = this.settings.resourcesUrl.replace(
          "FILE_PATH",
          this.info.photo
        );
      else studentPhoto.src = "/resources/images/blank.png";

      let imageSize = 39; // Adjust this to the desired image size
      let centerX = page_width / 2; // Adjust this to the desired X coordinate
      let centerY = 50; // Adjust this to the desired Y coordinate

      // Create a circular clipping path using context2d
      ctx.save();
      ctx.beginPath();
      ctx.arc(centerX, centerY, imageSize / 2, 0, Math.PI * 2);
      ctx.clip();

      // Draw the original image within the circular clipping path
      ctx.drawImage(
        studentPhoto,
        centerX - imageSize / 2,
        centerY - imageSize / 2,
        imageSize,
        imageSize
      );

      // Reset the clipping path
      ctx.restore();
      ctx.closePath();
      // -------------------------------------------------------------

      doc.setFont("Amiri", "Bold");
      doc.setFontSize(22);
      doc.setTextColor("#ffffff");
      doc.text(
        page_width / 2,
        78,
        this.capitalizeFirstLetter(
          this.info.firstName + (this.info.middleName ? " " + this.info.middleName : "") + " " + this.info.lastName
        ),
        { align: "center" }
      );
      doc.setFont("Amiri", "normal");
      doc.setFontSize(15);
      doc.text(
        page_width / 2,
        88,
        this.info.classRoom ? this.info.classRoom.name : "NON INSCRIT",
        {
          align: "center",
        }
      );

      let logo = "data:image/jpeg;base64, ";

      await axios
        .get(schoolLogo || "favicon.png", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          logo += Buffer.from(response.data, "binary").toString("base64");
        });

      await new AwesomeQR({
        text: this.qrData,
        logoImage: logo,
        size: 200,
        correctLevel: 1,
        logoScale: 0.2,
        logoMargin: 0,
        logoCornerRadius: 8,
        whiteMargin: false,
        dotScale: 1,
        autoColor: true,
        binarize: false,
        binarizeThreshold: 128,
        bindElement: true,
        backgroundColor: "#FFFFFF",
        margin: 3,
      })
        .draw()
        .then((dataURL) => {
          doc.addImage(
            dataURL,
            "PNG",
            page_width / 2 - 17.5,
            page_height / 1.5,
            35,
            35
          );
        });

      // logo and school name
      // -------------------------------------------------------------
      imageSize = 15;
      const text = schoolName;
      centerX = page_width / 2;
      centerY = 15;
      const padding = 5;
      doc.setFontSize(13);

      const totalWidth = imageSize + padding + doc.getTextWidth(text);
      const startX = centerX - totalWidth / 2;

      doc.addImage(
        imgData,
        "JPEG",
        startX,
        centerY - imageSize / 2,
        imageSize,
        imageSize
      );

      doc.setTextColor("#000000");

      doc.text(startX + imageSize + padding, centerY, text);
      // -------------------------------------------------------------

      this.loadingBadge = false;

      doc.save(
        "badge_" + this.info.lastName + "_" + this.info.firstName + ".pdf"
      );
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getQrImage(dataUrl) {
      this.qrDataImage = dataUrl;
    },

    reload(data) {
      this.$emit("reload");
    },
    onCancelInscription() {
      apiClient
        .post(`/payment/scolarite/cancel/${this.studentId}`)
        .then((res) => {
          this.$message.success(this.$t("success.InscriptionAnnulee"));
          this.$emit("reload");
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.errorCode) {
            this.$message.error(
              this.$t(`errorCode.${e.response.data.errorCode}`)
            );
          } else {
            this.$message.error(this.$t("error.InscriptionAnnulee"));
          }
        });
    },
    showRepReductionModal(changeClassRoom) {
      this.selectedClassRoom =
        this.classRoomList.find((c) => c._id == changeClassRoom) || {};

      const oldClassRoom = this.info.classRoom;
      this.changeClassRoomDisable = true;

      if (oldClassRoom == undefined) {
        this.visibleRepReductionModal = true;
      } else this.changeClassRoom();
    },
    closeRepReductionModal() {
      this.visibleRepReductionModal = false;
      this.loadingClassroomChange = false;
      this.changeClassRoomDisable = false;

      this.form.setFieldsValue({
        classRoom: this.info.classRoom ? this.info.classRoom._id : "",
      });
    },
    initNewInscription() {
      const selectedClassroomId = this.selectedClassRoom._id;

      this.loadingClassroomChange = true;
      let newSchoolarYearHistory = this.info.schoolarYearsHistory
        ? this.info.schoolarYearsHistory
        : {};

      newSchoolarYearHistory[this.settings.activeSchoolarYear] =
        selectedClassroomId;
      const newClassRoom = this.classRoomList.filter(
        (c) => c.id == selectedClassroomId
      )[0];

      const student = this.info;
      const activeSchoolarYear = this.settings.activeSchoolarYear;
      const schoolarYears = this.settings.schoolarYears;
      let newInscription = {};
      schoolarYears.forEach((elem) => {
        if (elem._id == activeSchoolarYear) {
          newInscription.end = elem.end;
          newInscription.start = elem.start;
        }
      });
      newInscription.student = student._id;
      newInscription.classroom = selectedClassroomId;
      newInscription.typeAS = "S";
      newInscription.mode = this.modePaiement;
      let repReduction = {};

      const range = getRangeMonthsSY(activeSchoolarYear, schoolarYears);
      if (newInscription.mode == "M")
        for (const key of range) repReduction[key] = 0;
      else if (this.selectedClassRoom.tranches)
        for (const e of this.selectedClassRoom.tranches)
          repReduction[e.trancheNumber] = 0;

      if (newClassRoom.inscription) repReduction["inscription"] = 0;

      newInscription.repReduction = repReduction;

      apiClient
        .put("/payment", newInscription)
        .then(async () => {
          await apiClient.patch("/students/" + student._id, {
            data: {
              classRoom: selectedClassroomId,
              schoolarYearsHistory: newSchoolarYearHistory,
            },
          });
          this.info.clasclassRoomsRoom = {
            ...newClassRoom,
            id: newClassRoom._id,
            _id: newClassRoom._id,
          };
          this.$message.success(this.$t("success.eleveAjoutAuClasse"));
          this.$emit("reload");
        })
        .catch((e) => {
          if (e.response && e.response.status === 403) {
            this.$message.error(this.$t("error.maxStudentsReached"));
            return;
          }
          console.error(e);
          this.$message.error(this.$t("error.eleveNonAjoutAuClasse"));
        })
        .finally(() => {
          this.changeClassRoomDisable = false;
          this.loadingClassroomChange = false;

          this.afterChangeClassRoom();
        });
    },
    async changeClassRoom() {
      const selectedClassroomId = this.selectedClassRoom._id;
      const student = this.info;
      const oldClassRoom = student.classRoom;

      await apiClient
        .patch("/payment/changeclass/" + student._id, {
          oldClassroomId: oldClassRoom,
          newClassroomId: selectedClassroomId,
        })
        .then((res) => {
          const newClassRoom = this.classRoomList.filter(
            (c) => c.id == selectedClassroomId
          )[0];
          this.$message.success(
            this.$t("success.eleveDemeangeAuClasse", {
              name: newClassRoom.name,
            })
          );

          this.$emit("reload");
        })
        .catch((error) => {
          showApiError(this, error);
        })
        .finally(() => {
          this.loadingClassroomChange = false;
          this.closeRepReductionModal();
          this.afterChangeClassRoom();
        });
      //////
    },
    afterChangeClassRoom() {
      apiClient
        .post("/payment/filter", {
          query: {
            student: this.studentId,
            schoolarYear: this.settings.activeSchoolarYear,
            typeAS: "S",
          },
          aggregation: [{ $sort: { updatedAt: 1 } }],
        })
        .then((res) => {
          if (res.data.length > 1) {
            const to_delete = res.data[0];
            apiClient.delete(`/payment/${to_delete._id}`);
            this.$emit("reload");
          }
        });
    },

    reverseStatModal() {
      this.visibleModal = !this.visibleModal;
    },
    addToStudentfileList(options) {
      const { onSuccess, onError, file, onProgress } = options;
      this.studentFiles.push(file);
      setTimeout(() => {
        onSuccess(null, file);
      }, 200);
    },
    beforeUploadStudentFiles(file) {
      // Check file type
      const allowedTypes = [
        // Images
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/bmp",

        // PDF
        "application/pdf",

        //text
        "text/plain",
        // Office files
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
      ];

      const allowedTypesLabel = "JPEG, JPG, PNG, BMP, PDF, TXT, .doc, .docx, .xls, .xlsx, .ppt, .pptx";
      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        this.$message.error(this.$t("error.allowedFileTypes", { types: allowedTypesLabel }));
      }

      const islt15 = this.studentFileList.length < 15;
      if (!islt15) {
        this.$message.error(this.$t("error.maxImage"));
      }

      let maxSize = 0;
      this.studentFileList.forEach((f) => {
        maxSize += f.size;
      });
      maxSize += file.size;
      maxSize = maxSize / 1024 / 1024;
      if (maxSize > 50) {
        this.$message.error(this.$t("error.image50"));
      }

      if (islt15 && maxSize <= 50 && isValidType) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        this.studentFileList.push(file);
      }
      return islt15 && maxSize <= 50 && isValidType;
    },
    removeFile(file) {
      this.studentFileList = this.studentFileList.filter(
        (f) => f.uid != file.uid
      );
      this.studentFiles = this.studentFiles.filter((f) => f.uid != file.uid);
    },
    getFileName(path) {
      return path.match(/\d+\-\-(.*?)$/)[1];
    },
    removeStudentFile(file) {
      this.info.files = this.info.files.filter(
        (f) => String(f) != String(file)
      );
      this.studentFileListToDelete.push(file);
    },
    removeBirthCertificate() {
      this.$set(this.info, "birthCertificate", null);
      this.birthCertificateFileList = [];
      this.birthCertificateFile = null;
      this.birthCertificateToDelete = true;
    },
    addToBirthCertificateList(options) {
      const { onSuccess, onError, file, onProgress } = options;
      this.birthCertificateFile = file;
      setTimeout(() => {
        onSuccess(null, file);
      }, 200);
    },
    beforeUploadBirthCertificate(file) {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/bmp",
        "application/pdf",
        "text/plain",
         // Office files
         "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
      ];

      const allowedTypesLabel = "JPEG, JPG, PNG, WEBP, BMP, PDF, TXT, .doc, .docx, .xls, .xlsx, .ppt, .pptx";
      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        this.$message.error(this.$t("error.allowedFileTypes", { types: allowedTypesLabel }));
        return false;
      }
      const islt5M = file.size / 1024 / 1024 < 5;
      if (!islt5M) {
        this.$message.error(this.$t("error.fileTooLarge") );
        return false;
      }

      if (isValidType && islt5M) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        this.birthCertificateFile = file;
      }
      return isValidType && islt5M;
    },
    handleChangeBirthCertificate(e) {
      if (e.file) {
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/webp",
          "image/bmp",
          "application/pdf",
          "text/plain",
           // Office files
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
        ];

        const isValidType = allowedTypes.includes(e.file.type);
        const islt5M = e.file.size / 1024 / 1024 < 5;

        if (isValidType && islt5M) {
          // Only keep the last file - single upload only
          this.birthCertificateFileList = e.fileList.slice(-1);
          e.file.status = "done";
        }
      }
    },
    handleChangeStudentFiles(e) {
      if (e.file) {
        // Check file type
        const allowedTypes = [
          // Images
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/bmp",
          // PDF
          "application/pdf",
          "text/plain",
          // Office files
          "application/msword", // .doc
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
          "application/vnd.ms-excel", // .xls
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
          "application/vnd.ms-powerpoint", // .ppt
          "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
        ];

        const isValidType = allowedTypes.includes(e.file.type);

        const islt15 = this.studentFiles.length < 15;

        let maxSize = 0;
        this.studentFiles.forEach((f) => {
          maxSize += f.size;
        });
        maxSize += e.file.size;
        maxSize = maxSize / 1024 / 1024;

        if (islt15 && maxSize <= 50 && isValidType) {
          this.studentFiles = e.fileList;
          e.file.status = "done";
        }
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    callback: function (key) {
      this.activeKey = key;
      if (key == 1) this.gtagPageView("Informations");
      else if (key == 2) this.gtagPageView("Paiement scolarité");
      else if (key == 3) this.gtagPageView("Paiements activités");
      else if (key == 6) this.gtagPageView("Qr code");
      // the others is in the components
    },
    updateStudent(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // --- Phone validation for TN/KE ---
          const phoneVal = (values.phone || "").trim();
          if (phoneVal) {
            const phoneDigits = phoneVal.replace(/\D/g, "");
            if (phoneVal.startsWith("+216") && phoneDigits.length !== 11) {
              this.$message.error(this.$t('requis.telephone'));
              return;
            }
            if (phoneVal.startsWith("+254") && phoneDigits.length !== 13) {
              this.$message.error(this.$t('requis.telephoneKE'));
              return;
            }
          }
          // --- End phone validation ---

          try {
            this.loadingUpdateStudent = true;
            let data = {
              ...values,
              BirthDate: moment(values.birthDay).valueOf(),
            };
            if (data.info.personalInfo) {
              data.personalInfo = data.info.personalInfo;
              delete data.info;
            }
            delete data.birthDay;
            this.info.BirthDate = data.BirthDate;

            // Handle birth certificate deletion
            if (this.birthCertificateToDelete) {
              data.birthCertificate = "";
            }

            // Handle birth certificate upload
            if (this.birthCertificateFile) {
              const uploadedKeys = await uploadFilesToS3(
                [this.birthCertificateFile],
                "manager/student/birthCertificate",
                this.progress
              );
              data.birthCertificate = uploadedKeys[0];
            }

            // Handle student files upload
            if (this.studentFileList.length > 0) {
              const uploadedKeys = await uploadFilesToS3(
                this.studentFileList,
                "manager/student",
                this.progress
              );
              data.files = uploadedKeys;
            }

            // Handle file deletions first
            if (this.studentFileListToDelete.length > 0) {
              try {
                await apiClient.post(
                  "/students/" + this.info._id + "/deleteFiles",
                  {
                    files: this.studentFileListToDelete,
                  }
                );
              } catch (error) {
                this.$message.error(this.$t("error.erreur"));
                return; // Stop if file deletion fails
              }
            }

            // Handle SACCO fields transformation
            if (data.saccoName || data.saccoBankName) {
              data.sacco = {
                name: data.saccoName || "",
                bankDetails: {
                  name: data.saccoBankName || "",
                },
              };
              delete data.saccoName;
              delete data.saccoBankName;
            }

            // Update student data
            if (data.parent) {
              if (data.parent.father) {
                data.parent.father = flattenToDotNotation(data.parent.father);
              }
              if (data.parent.mother) {
                data.parent.mother = flattenToDotNotation(data.parent.mother);
              }
              if (data.parent.guardian) {
                data.parent.guardian = flattenToDotNotation(
                  data.parent.guardian
                );
              }
            }
            const response = await apiClient.patch(
              "/students/" + this.info._id,
              { data }
            );

            // Update local state
            this.info = {
              ...this.info,
              adress: values.adress,
              postalAddress: values.postalAddress,
              physicalAddress: values.physicalAddress,
              firstName: values.firstName,
              middleName: values.middleName,
              lastName: values.lastName,
              medicalNotes: values.medicalNotes,
              noteForTeachers: values.noteForTeachers,
              gender: values.gender,
              notes: values.notes,
              phone: values.phone,
              ...(this.countryIsKE
                ? { nemisNumber: values.nemisNumber }
                : { uniqueId: values.uniqueId }
              ),
              birthCertificate: response.data.student.birthCertificate,
              files: response.data.student.files,
              sacco: response.data.student.sacco || this.info.sacco,
              healthInfo: response.data.student.healthInfo || this.info.healthInfo || {},
            };

            this.$message.success(this.$t("success.eleveMSA"));
          } catch (e) {
            this.$message.error(this.$t("error.impoModifiEleve"));
          } finally {
            // Reset all states
            this.loadingUpdateStudent = false;
            this.progress = { value: 0 };
              this.studentFiles = [];
              this.studentFileList = [];
              this.birthCertificateFileList = [];
              this.birthCertificateFile = null;
              this.birthCertificateToDelete = false;
              this.studentFileListToDelete = [];
            }
        }
      });
    },
    handleParentChange(value) {
      this.loadingParentChange = true;
      apiClient
        .post(`/students/${this.info._id}/changeParent`, {
          oldParent: this.info.parent._id,
          newParent: value,
        })
        .then((res) => {
          this.info.parent._id = value;
          this.$message.success(this.$t("success.eleveMSA"));
          this.loadingParentChange = false;
          this.$emit("reload");
        })
        .catch((e) => {
          console.error(e);

          this.$message.error(this.$t("error.erreur"));
        });
    },
    requestNameChange(field, action) {
      apiClient
        .patch(`/lms/student/${this.info._id}/validateName`, {
          field,
          action,
        })
        .then((res) => {
          if (res.data) {
            if (action === "approve") {
              this.info[field] = this.info.needValidation[field];
            }
            if (this.info.needValidation) {
              this.$set(this.info.needValidation, field, false);
              const noNameValidationsLeft =
                !this.info.needValidation.firstName &&
                !this.info.needValidation.lastName;
              if (noNameValidationsLeft) {
                this.$set(this.info, "needValidation", null);
              }
            }
            this.$message.success(
              action === "approve"
                ? this.$t("profil.approuver")
                : this.$t("profil.rejeter")
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$message.error(this.$t("error.erreur"));
        });
    },
    transformStudentData(record) {
      this.activeStudent = record.id;
      this.activeParent = record.parent;

      let fichePersonnelData = {
        studentPhoto: record.photo,
        studentName: `${record.firstName}${record.middleName ? ' ' + record.middleName : ''} ${record.lastName}`,
        uniqueId: record.uniqueId || "",
        birthDate: moment(record.BirthDate).format("DD/MM/YYYY"),
        birthPlace: record.birthPlace || "",

        fatherName: `${record.parent.father.firstName} ${record.parent.father.lastName}`,
        fatherJob: record.parent.father.job || "",

        motherName: `${record.parent.mother.firstName} ${record.parent.mother.lastName}`,
        motherJob: record.parent.mother.job || "",

        numberOfChildren: record.parent.numberOfChildren,
        adress: record.adress || "",
        financialStatus: record.parent.financialStatus,

        numberOfRegistrations: record.personalInfo
          ? record.personalInfo.numberOfRegistrations
          : null,
        entryDate:
          record.personalInfo && record.personalInfo.entryDate
            ? moment(record.personalInfo.entryDate).format("DD/MM/YYYY")
            : null,
        exitDate:
          record.personalInfo && record.personalInfo.exitDate
            ? moment(record.personalInfo.exitDate).format("DD/MM/YYYY")
            : null,
        exitReason: record.personalInfo ? record.personalInfo.exitReason : "",
        previousInstitution: record.personalInfo
          ? record.personalInfo.previousInstitution
          : "",
        secondarySchool: record.personalInfo
          ? record.personalInfo.secondarySchool
          : "",
        attachedDocs: record.personalInfo
          ? record.personalInfo.attachedDocs
          : "",
        notes: record.notes || "",
        effort: record.personalInfo ? record.personalInfo.effort : "",
        behavior: record.personalInfo ? record.personalInfo.behavior : "",
        attendance: record.personalInfo ? record.personalInfo.attendance : "",
      };
      return fichePersonnelData;
    },
    async generateFichePersonnelPDF(option) {
      console.info(option);
      const userProfileImage = option.key == "wihtPhoto";
      const pdfData = this.transformStudentData(this.info);
      console.info(pdfData);
      this.loadingData = true;

      const doc = new JsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        hotfixes: ["px_scaling"],
      });

      doc.setFont("Amiri");

      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();
      const lineSpacing = 11;
      const valueOffset = 5;

      const loadBackgroundImage = () => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.onload = () => resolve(img);
          img.onerror = (err) => {
            console.error("Error loading background image:", err);
            reject(err);
          };
          img.src = "/resources/images/frame.png";
        });
      };

      try {
        const bgImg = await loadBackgroundImage();
        doc.addImage(bgImg, "JPEG", 0, 0, pdfWidth, pdfHeight);
      } catch (error) {
        console.error("Error adding background image to PDF:", error);
      }

      let yPos = 20;
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0);
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);

      doc.rect(15, yPos, 30, 15);
      const registrationNum = String(pdfData.numberOfRegistrations || "");
      const registrationLabel = "عدد الترسيم";
      const regLabelWidth = doc.getTextWidth(registrationLabel);
      const regNumWidth = doc.getTextWidth(registrationNum);
      doc.text(registrationLabel, 15 + 15 - regLabelWidth / 2, yPos + 5);
      doc.text(registrationNum, 15 + 15 - regNumWidth / 2, yPos + 12);

      doc.setFontSize(32);
      const title = "مذكرة شخصية";
      let titleWidth = doc.getTextWidth(title);
      doc.text(title, pdfWidth / 2 - titleWidth / 2, yPos + 7);

      doc.setFontSize(22);
      const photoX = pdfWidth - 45;
      const photoY = yPos - 5;
      const photoWidth = 35;
      const photoHeight = 40;
      doc.rect(photoX, photoY, photoWidth, photoHeight);
      if (userProfileImage && pdfData.studentPhoto) {
        try {
          const studentPhotoURL = this.settings.resourcesUrl.replace(
            "FILE_PATH",
            pdfData.studentPhoto
          );
          const loadImage = () => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = "Anonymous";
              img.onload = () => resolve(img);
              img.onerror = (err) => {
                console.error("Error loading image:", err);
                reject(err);
              };
              img.src = studentPhotoURL;
            });
          };

          const img = await loadImage();
          const imgAspectRatio = img.width / img.height;
          const rectAspectRatio = photoWidth / photoHeight;
          let finalWidth, finalHeight;
          if (imgAspectRatio > rectAspectRatio) {
            finalWidth = photoWidth - 2;
            finalHeight = finalWidth / imgAspectRatio;
          } else {
            finalHeight = photoHeight - 2;
            finalWidth = finalHeight * imgAspectRatio;
          }
          const xOffset = (photoWidth - finalWidth) / 2;
          const yOffset = (photoHeight - finalHeight) / 2;

          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          const imageData = canvas.toDataURL("image/jpeg");

          doc.addImage(
            imageData,
            "JPEG",
            photoX + xOffset,
            photoY + yOffset,
            finalWidth,
            finalHeight
          );
        } catch (error) {
          console.error("Error adding student photo to PDF:", error);
        }
      }

      yPos += 30;
      // Get school details for dynamic school type
      const schoolDetails = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0];
      const schoolTypeAr = getSchoolTypeLabel(
        schoolDetails,
        "ar-AR" // PDF is always in Arabic
      );
      const schoolName = schoolTypeAr;
      const arabicSchoolName = schoolDetails ? schoolDetails.ArabicName : "";
      doc.setFontSize(16);
      let schoolNameWidth = doc.getTextWidth(schoolName);
      doc.text(schoolName, pdfWidth / 2 - schoolNameWidth / 2, yPos);

      if (arabicSchoolName) {
        yPos += 7;
        schoolNameWidth = doc.getTextWidth(arabicSchoolName);
        doc.text(arabicSchoolName, pdfWidth / 2 - schoolNameWidth / 2, yPos);
      }

      yPos += 15;
      doc.setFontSize(12);

      const drawField = (
        xRight,
        columnWidth,
        label,
        value,
        y,
        isPaired = false,
        isSecondField = false
      ) => {
        const labelText = `: ${label}`;
        const labelWidth = doc.getTextWidth(labelText);

        doc.text(labelText, xRight, y, { align: "right" });

        const availableValueWidth = isPaired
          ? isSecondField
            ? columnWidth - labelWidth - valueOffset
            : columnWidth - labelWidth - valueOffset + 10
          : columnWidth - labelWidth - valueOffset;

        const valueStr = value != null ? String(value).trim() : "";

        if (valueStr) {
          if (isPaired) {
            if (doc.getTextWidth(valueStr) > availableValueWidth) {
              let truncatedText = valueStr;
              while (
                doc.getTextWidth(truncatedText + "...") > availableValueWidth &&
                truncatedText.length > 0
              ) {
                truncatedText = truncatedText.slice(0, -1);
              }
              truncatedText += "...";
              doc.text(truncatedText, xRight - labelWidth - valueOffset, y, {
                align: "right",
              });
            } else {
              doc.text(valueStr, xRight - labelWidth - valueOffset, y, {
                align: "right",
              });
            }
            return y;
          } else {
            // For single fields, allow multi-line text
            const splittedText = doc.splitTextToSize(
              valueStr,
              availableValueWidth
            );

            for (let i = 0; i < splittedText.length; i++) {
              const currentY = y + i * lineSpacing;
              doc.text(
                splittedText[i],
                xRight - labelWidth - valueOffset,
                currentY,
                { align: "right" }
              );
            }

            return y + (splittedText.length - 1) * lineSpacing;
          }
        } else {
          const dottedLineEnd = xRight - labelWidth - valueOffset;
          const dottedLineStart = dottedLineEnd - availableValueWidth;

          const leftMargin = 20;
          const adjustedDottedLineStart =
            dottedLineStart < leftMargin ? leftMargin : dottedLineStart;

          doc.setLineDashPattern([1, 1], 0);
          doc.line(adjustedDottedLineStart, y + 1, dottedLineEnd, y + 1);
          doc.setLineDashPattern([], 0);

          return y;
        }
      };

      const addFieldSingle = (label, value, y) => {
        const xRight = pdfWidth - 20;
        const columnWidth = pdfWidth - 40;
        return (
          drawField(xRight, columnWidth, label, value, y, false) + lineSpacing
        );
      };

      const addFieldPair = (labelA, valueA, labelB, valueB, y) => {
        const columnAWidth = (pdfWidth - 40) * 0.55;
        const columnBWidth = (pdfWidth - 40) * 0.45;

        const xRightA = pdfWidth - 20;
        const xRightB = pdfWidth / 2 - 10;
        const yA = drawField(
          xRightA,
          columnAWidth,
          labelA,
          valueA,
          y,
          true,
          false
        );
        const yB = drawField(
          xRightB,
          columnBWidth,
          labelB,
          valueB,
          y,
          true,
          true
        );

        return Math.max(yA, yB) + lineSpacing;
      };

      yPos = addFieldSingle("المعرف الوحيد", pdfData.uniqueId || "", yPos);

      yPos = addFieldPair(
        "الإسم",
        this.info.firstName + (this.info.middleName ? " " + this.info.middleName : ""),
        "اللقب",
        this.info.lastName,
        yPos
      );

      yPos = addFieldPair(
        "تاريخ الولادة",
        pdfData.birthDate || "",
        "مكانها",
        pdfData.birthPlace || "",
        yPos
      );

      yPos = addFieldPair(
        "اسم الأب ولقبه",
        pdfData.fatherName || "",
        "المهنة",
        pdfData.fatherJob || "",
        yPos
      );

      yPos = addFieldPair(
        "اسم الأم ولقبها",
        pdfData.motherName || "",
        "المهنة",
        pdfData.motherJob || "",
        yPos
      );

      const personalFields = [
        { label: "عدد الأبناء", value: pdfData.numberOfChildren },
        {
          label: "الحالة المادية للأسرة",
          value: pdfData.financialStatus,
        },
        { label: "العنوان", value: pdfData.adress },
        { label: "تاريخ الدخول", value: pdfData.entryDate },
        {
          label: "متأتي روضة",
          value: pdfData.previousInstitution || "",
        },
        { label: "تاريخ الخروج", value: pdfData.exitDate },
        { label: "السبب", value: pdfData.exitReason },
        {
          label: "المعهد الثانوي الذي ارتقى إليه",
          value: pdfData.secondarySchool,
        },
        {
          label: "الوثائق المصاحبة",
          value: pdfData.attachedDocs,
        },
        { label: "ملاحظات", value: pdfData.notes },
        { label: "الاجتهاد", value: pdfData.effort },
        { label: "السيرة", value: pdfData.behavior },
        { label: "المواظبة", value: pdfData.attendance },
      ];
      personalFields.forEach((field) => {
        yPos = addFieldSingle(field.label, field.value || "", yPos);
      });

      this.loadingData = false;

      doc.save("fiche_personnelle.pdf");
    },
  },
};
</script>
<style scoped>
::v-deep .ant-form-item-label label {
  margin-bottom: 0px;
}

.card {
  height: 90%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.custom-tag .ant-tag {
  padding: 4px 7px 4px 7px;
  font-size: 13px;
  margin-left: 3px;
}

.custom-tag .ant-tag:hover {
  cursor: pointer;
}

.custom-border {
  border: 1px solid #6c757d;
  border-radius: 0.25rem;
  cursor: pointer;
}

.custom-border-active {
  border: 3px solid #22bb33;
  border-radius: 0.25rem;
  cursor: pointer;
}

.name-changes-alert {
  padding: 8px 0;
}

.clickable-icon {
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.clickable-icon:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.rtl-direction {
  direction: rtl;
  text-align: right;
}

.parent-photo-consent-wrap {
  max-width: 100%;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
}

.parent-photo-consent-title {
  font-size: 10.5px;
  line-height: 1.25;
  font-weight: 600;
  text-align: center;
  color: #888;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  padding: 2px 2px 6px;
  margin: 0;
  text-transform: none;
}

.parent-photo-consent-hint {
  font-size: 9px;
  line-height: 1.25;
  word-wrap: break-word;
  overflow-wrap: anywhere;
  padding: 0 2px;
}
</style>
